import { PaymentMethodModal } from "~/features/payment/modal/payment-method-modal/index.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

import type { PrepayTenderFlow } from "../hooks/use-prepay-tender-flow.ts";

type PrepayTenderModalsProps = {
	readonly flow: PrepayTenderFlow;
};

export const PrepayTenderModals = ({ flow }: PrepayTenderModalsProps) => {
	const {
		paymentMethods,
		selectedPaymentValue,
		showPaymentMethodModal,
		pendingPayment,
		formattedAmount,
		confirmLastFour,
		confirmAccountType,
		handleApplyPaymentMethod,
		handleClosePaymentMethodModal,
		handleCancelConfirmation,
		handleConfirmPayment,
	} = flow;

	return (
		<>
			{showPaymentMethodModal ? (
				<PaymentMethodModal
					availablePaymentMethods={paymentMethods}
					handleApplyPaymentMethod={handleApplyPaymentMethod}
					onClose={handleClosePaymentMethodModal}
					selectedPaymentValue={selectedPaymentValue}
				/>
			) : null}
			{pendingPayment ? (
				<TraxModal
					showConfirmationButtons
					cancelText={"Cancel"}
					confirmText={"Submit Payment"}
					onCancel={handleCancelConfirmation}
					onClose={handleCancelConfirmation}
					onConfirm={handleConfirmPayment}
					title={"Confirm Payment"}
					type={"confirmation"}
				>
					<div data-testid={"prepay-confirmation-content"}>
						<p>
							Submit a payment of <strong>{formattedAmount}</strong> using{" "}
							<strong>
								{confirmAccountType}
								{confirmLastFour ? ` ending in ${confirmLastFour}` : ""}
							</strong>
							?
						</p>
						<p>This payment is required to tender your shipment.</p>
					</div>
				</TraxModal>
			) : null}
		</>
	);
};
